// Domain
const DOMAIN = 'lending.services.public.onboarding.lzOnboarding.genericComponents.errorAccordion.';

const COPY_TEXT = `${DOMAIN}copyAllButton`,
  SHOW_DETAILS = `${DOMAIN}showMoreDetails`;

export { COPY_TEXT, SHOW_DETAILS };
